import {useTranslation} from 'react-i18next';
import {ConfirmationDialog} from 'components/dialogs/ConfirmationDialog';
import Typography from '@mui/material/Typography';
import React from 'react';

type OverwriteConfirmationProps = {
   open: boolean;
   includeExport?: boolean;
   keyType: string;
   keyName?: string;
   onCancel: () => void;
   onOk: () => void;
};

const OverwriteConfirmation = ({
   open,
   includeExport = false,
   keyType,
   onCancel,
   onOk,
   keyName,
}: OverwriteConfirmationProps) => {
   const {t} = useTranslation();

   return (
      <ConfirmationDialog
         open={open}
         title={t('Duplicate Key Name')}
         content={
            <>
               <Typography>
                  {t('Diplomat already contains {{keyType}} named {{keyName}}', {
                     keyType,
                     keyName,
                  })}
               </Typography>
               <br />
               <Typography>
                  {t(
                     'If you overwrite {{keyName}}, you cannot recover the original key at a later time.',
                     {
                        keyName,
                     }
                  )}
                  {includeExport && (
                     <>
                        {' '}
                        {t(
                           'We recommend that you export a copy of {{keyName}} before you overwrite it.',
                           {
                              keyName,
                           }
                        )}
                     </>
                  )}
               </Typography>
               <br />
               <Typography>{t('Do you want to overwrite the existing key now?')}</Typography>
            </>
         }
         confirmLabel={t('Yes')}
         cancelLabel={t('No')}
         onCancel={onCancel}
         onOk={onOk}
      />
   );
};

export default OverwriteConfirmation;
